module.exports = __webpack_public_path__ + "img/it4d-e-samu-blank.8b7e5c59.png";